<template>
  <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="15" cy="15" r="15" fill="#DBEDDD" />
    <path d="M8.58216 8.58133L8.58216 10.8784L17.6808 10.8865L7.7676 20.7997L9.39672 22.4288L19.3099 12.5157L19.3018 21.6143L21.6151 21.6143L21.6151 8.58133L8.58216 8.58133Z" fill="#22AB30" />
  </svg>
</template>
